import { CUSTOM_ELEMENTS_SCHEMA, NgModule, ErrorHandler } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { InicioMatriculacionComponent } from './inicio-matriculacion/inicio-matriculacion.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { authInterceptorProviders } from './_helpers/auth.interceptor';
import { NotfoundComponent } from './notfound/notfound.component';
import { JwtHelperService, JwtModule } from '@auth0/angular-jwt';
import { TokenStorageService } from './_services/token-storage.service';
import { InfoFirmasComponent } from './info-firmas/info-firmas.component';
import { BuscarTramiteComponent } from './buscar-tramite/buscar-tramite.component';
import { ProcesofirmaErrorComponent } from './info-procesofirma/error/procesofirma-error.component';
import { ProcesofirmaIniciadoComponent } from './info-procesofirma/iniciado/procesofirma-iniciado.component';
import { AltaUsuarioComponent } from './alta-usuario/alta-usuario.component';
import { GestionUsuariosComponent } from './gestion-usuarios/gestion-usuarios.component';
import { DataTablesModule } from 'angular-datatables';
import { EditarUsuarioComponent } from './editar-usuario/editar-usuario.component';
import { VistaQrComponent } from './vista-qr/vista-qr.component';
import { VistaErrorQrComponent } from './vista-error-qr/vista-error-qr.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { CustomErrorHandler } from './_services/handle-error';
import { NoAutorizadoComponent } from './no-autorizado/no-autorizado.component';
import { NgxMaskModule } from 'ngx-mask';


export function tokenGetter() {
  let tokenStorage = new TokenStorageService();
  return tokenStorage.getToken();
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    InicioMatriculacionComponent,
    NotfoundComponent,
    InfoFirmasComponent,
    BuscarTramiteComponent,
    ProcesofirmaIniciadoComponent,
    ProcesofirmaErrorComponent,
    AltaUsuarioComponent,
    GestionUsuariosComponent,
    EditarUsuarioComponent,
    VistaQrComponent,
    VistaErrorQrComponent,
    NoAutorizadoComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    NgxExtendedPdfViewerModule,
    DataTablesModule,
    NgxSpinnerModule,
    HttpClientModule,
    NgxMaskModule.forRoot(),
    JwtModule.forRoot({ config: { tokenGetter: tokenGetter } })
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [FileList, authInterceptorProviders, JwtHelperService, InfoFirmasComponent],
  bootstrap: [AppComponent]
})
export class AppModule { }
